import { Navigate, useLocation } from 'react-router-dom';
import { useBrandManager } from '@/contexts/BrandProvider';

interface LearnAdminProtectedRouteProps {
  children: React.ReactNode;
}

export const LearnAdminProtectedRoute: React.FC<LearnAdminProtectedRouteProps> = ({ children }) => {
  const { currentBrand, isLoading, isInitializing } = useBrandManager();
  const location = useLocation();

  // Wait for brand context to initialize and fetch brands before deciding
  if (isInitializing || isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!currentBrand) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};
